type BetRange = { label: string; value: string };
type Translate = (key: string, fallback: string) => string;

// Hidden outright on uBTC: the amounts are not denominated in it and would read as wildly wrong.
const formatBetRange = (
  minBet: number | undefined,
  maxBet: number | undefined,
  currency: string | undefined,
  t: Translate,
): BetRange | undefined => {
  if (currency === "uBTC") return undefined;

  const unit = currency ? ` ${currency}` : "";

  if (minBet && maxBet) {
    return {
      label: t("game.stats.betrange.minmax", "Min - Max bet"),
      value: `${minBet} - ${maxBet}${unit}`,
    };
  }
  if (minBet) {
    return {
      label: t("game.stats.betrange.min", "Min bet"),
      value: `${minBet}${unit}`,
    };
  }
  if (maxBet) {
    return {
      label: t("game.stats.betrange.max", "Max bet"),
      value: `${maxBet}${unit}`,
    };
  }
  return undefined;
};

export default formatBetRange;
